import Vue from 'vue'
import App from './App.vue'
import router from './router'


import 'amfe-flexible';

Vue.config.productionTip = false

import {checkQiNiuUrl} from '@/utils/common'
Vue.prototype.checkQiNiuUrl = checkQiNiuUrl

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
